import React from "react";
import routeGuard from "src/HOC/routeGuard";
import GNCSimulatorList6DOF from "src/components/GNCSimulator6DOF/list";
import { RESOURCE_TYPE } from "src/constant/common";

const GNC6DOFSimulator = () => {
  return <GNCSimulatorList6DOF />;
};

export default routeGuard(GNC6DOFSimulator, RESOURCE_TYPE.GNC_SIMULATION);
